var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"empresa-view"},[_c('div',{staticClass:"empresa-content"},[_c('h1',{staticStyle:{"color":"greenyellow","margin-top":"60px","padding-left":"40px","width":"max-content"}},[_vm._v("Empresa")])])]),_c('div',{staticClass:"empresa-paragraph-container"},[_c('p',{staticClass:"paragraph"},[_vm._v(" Pantalla en construcción ")])])])
}]

export { render, staticRenderFns }